import { rankingItems } from '@/mocks/home';

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-accent-100/80 border border-accent-200/60 text-accent-700 text-xs font-semibold mb-4 whitespace-nowrap">
            <i className="ri-trophy-line text-sm"></i>
            热度榜单
          </div>
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">热门爆料排行榜</h2>
          <p className="text-sm text-foreground-500 max-w-2xl mx-auto">基于浏览量和讨论热度的实时更新榜单，看看大家都在关注什么瓜。</p>
        </div>

        <div className="max-w-2xl mx-auto bg-background-50 rounded-lg border border-background-200/70 overflow-hidden">
          {rankingItems.map((item, index) => (
            <div
              key={item.id}
              className={`flex items-center gap-4 px-5 py-4 border-b border-background-100 last:border-b-0 hover:bg-background-100/50 transition-colors duration-200 cursor-pointer ${
                index === 0 ? 'bg-primary-50/50' : ''
              }`}
            >
              <div className={`flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold ${
                item.rank === 1 ? 'bg-primary-500 text-background-50' :
                item.rank === 2 ? 'bg-accent-500 text-background-50' :
                item.rank === 3 ? 'bg-secondary-500 text-background-50' :
                'bg-background-100 text-foreground-500'
              }`}>
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-sm md:text-base font-medium text-foreground-800 truncate">{item.title}</p>
              </div>
              {item.tag && (
                <span className="flex-shrink-0 px-2 py-0.5 bg-primary-100 text-primary-700 text-xs font-bold rounded whitespace-nowrap">{item.tag}</span>
              )}
              <div className="flex-shrink-0 flex items-center gap-1 text-sm">
                <span className={`text-xs ${
                  item.trend === 'up' ? 'text-primary-500' :
                  item.trend === 'down' ? 'text-foreground-400' :
                  'text-foreground-400'
                }`}>
                  {item.trend === 'up' ? '↑' : item.trend === 'down' ? '↓' : '−'}
                </span>
                <span className="text-xs text-foreground-500 whitespace-nowrap">{item.hot}热度</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}